import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PointModel} from "../models/point.model";
import {PerfectScrollbarComponent} from "ngx-perfect-scrollbar";
import {GoogleMapsService} from "../services/googleMaps.service";
import {AngularFirestore} from "angularfire2/firestore";
import {FavouriteType} from "../types/favourite.type";
import {AppModeEnum} from "../enums/appMode.enum";
import {UserFavourites} from "../models/userFavourites.model";
import {TripModel} from "../models/trip.model";
import {CoordinatesModel} from "../models/coordinates.model";

@Component({
  selector: 'trips-list',
  templateUrl: './trips-list.component.html',
  styleUrls: ['./trips-list.component.scss']
})
export class TripsListComponent implements OnInit, OnChanges {

  @ViewChild('perfectScrollbar') perfectScrollbar: PerfectScrollbarComponent;
  @Input() appMode: AppModeEnum;
  @Input() trips: TripModel[];
  @Input() currentCoordinates: CoordinatesModel;
  @Input() selectedTrip: TripModel;
  @Input() selectedTripPoint: TripModel;
  @Input() havePlansToJoin: void;
  @Output() selectedTripChange: EventEmitter<TripModel> = new EventEmitter<TripModel>();
  @Output() selectedTripPointChange: EventEmitter<TripModel> = new EventEmitter<TripModel>();
  @Output() drawTripPointsDirection: EventEmitter<any> = new EventEmitter<any>();
  @Output() drawTripDirection: EventEmitter<TripModel> = new EventEmitter<TripModel>();

  public user: any;

  constructor( public googleMapsService: GoogleMapsService, private db: AngularFirestore ) {
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('RandomRideUserInfo'));
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.selectedPoint){
      this.scrollToSelectedTrip();
    }
  }

  public scrollToSelectedTrip(){
    setTimeout(()=>{
      let querySelector = '#tripsListPerfectScrollbar li.active';
      this.perfectScrollbar.directiveRef.scrollToElement(querySelector, 0, 300);
    }, 10);
  }

  public selectTripPoint(point, trip, $event?){
    $event && $event.stopPropagation();
    this.selectWholeTrip(trip);
    this.selectedTripPointChange.emit(point);
  }

  public selectWholeTrip(trip, $event?){
    $event && $event.stopPropagation();
    // if(event === this.selectedEvent) {
    //   event = null;
    // }
    this.selectedTripChange.emit(trip);
  }

  public drawDirectionToPoint(point, trip, $event?){
    $event && $event.stopPropagation();
    this.selectTripPoint(point, trip);
    this.drawTripPointsDirection.emit({
      origin: this.currentCoordinates,
      destination: point
    });
  }

  public drawDirectionBetweenPoints(point1, point2, trip, $event?){
    $event && $event.stopPropagation();
    this.selectTripPoint(point1, trip);
    this.drawTripPointsDirection.emit({
      origin: point1,
      destination: point2
    });
  }

  public drawWholeTripDirection(trip, $event?){
    $event && $event.stopPropagation();
    this.drawTripDirection.emit(trip);
  }

  public exportTrips(){
    this.trips.forEach(trip => {
      this.db.collection('trips').add(trip).then(res => {

      });
    })
  }

  public dateComparator(itemA, itemB) {
    return +itemA > +itemB ? 1 : -1;
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/trips-list/trips-list.component.ts